// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- Direct source consumers include CSS types.
/// <reference path="./styles.d.ts" />
import type { HTMLAttributes, ReactNode } from "react";
import { Button, LiveRegion, Spinner } from "./controls";
import "./PageStatus.css";

export interface PageLoaderProps extends Omit<
  HTMLAttributes<HTMLDivElement>,
  "children"
> {
  label?: ReactNode;
}

export function PageLoader({
  className,
  label = "正在加载应用",
  ...props
}: PageLoaderProps) {
  return (
    <LiveRegion
      {...props}
      as="div"
      className={["ark-page-status", className].filter(Boolean).join(" ")}
    >
      <Spinner size="large" aria-hidden="true" />
      <span>{label}</span>
    </LiveRegion>
  );
}

export function ErrorState({
  extra,
  message = "应用加载失败",
  onRetry,
}: {
  extra?: ReactNode;
  message?: string;
  onRetry?: () => void;
}) {
  return (
    <LiveRegion
      as="div"
      className="ark-page-status ark-page-error"
      politeness="assertive"
    >
      <h2>{message}</h2>
      <p>请检查网络连接或联系平台管理员。</p>
      {extra ??
        (onRetry ? (
          <Button type="primary" onClick={onRetry}>
            重新加载
          </Button>
        ) : null)}
    </LiveRegion>
  );
}
